import { render, staticRenderFns } from "./multiple-attention-modal.vue?vue&type=template&id=3885a630&scoped=true"
import script from "./multiple-attention-modal.vue?vue&type=script&lang=js"
export * from "./multiple-attention-modal.vue?vue&type=script&lang=js"
import style0 from "./multiple-attention-modal.vue?vue&type=style&index=0&id=3885a630&prod&scoped=true&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3885a630",
  null
  
)

export default component.exports